module.exports = __webpack_public_path__ + "media/images/mypage/icon/green-pale/ico_user-1b25f76bd521208616e67ed750ebc012.svg";